// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"dca-z","subtitle":"eca-z","wrapper":"fca-z","leftArrow":"gca-z","rightArrow":"hca-z"};